import React, { useEffect } from 'react';
import { maintainImage } from '../../../assets/images';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { IMetadata } from '../../atoms/Metadata/interface';
import { Metadata } from '../../atoms';

const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;
const MaintainScreenSection = ({ metadata }: { metadata?: IMetadata }) => {
  const router = useRouter();
  useEffect(() => {
    if (sessionStorage.getItem('after_login_redirect') === 'true') {
      sessionStorage.removeItem('after_login_redirect');
      router.replace(PUBLIC_URL);
    }
  }, []);

  return (
    <React.Fragment>
      <Metadata {...metadata} />
      <div className="container flex flex-col justify-center items-center h-screen lg:h-[496px]">
        <Image
          className="h-[200px] w-auto"
          src={maintainImage.src}
          alt="not found image"
          width={200}
          height={200}
        />
        <p className="text-reliableBlack text-xl lg:text-2xl font-bold mb-2 mt-[32px] lg:mt-[41px]">
          Sedang Dalam Perbaikan
        </p>
        <p className="text-reliableBlack text-sm lg:text-lg text-center">
          Kami sedang dalam perbaikan. Silakan berkunjung lagi nanti.
        </p>
        <div className="mb-[30px] mt-6 lg:mb-0 lg:mt-[41px] w-full lg:w-auto">
          <div
            onClick={() => (window.location.href = '/')}
            className="py-4 lg:px-6 rounded-[4px] text-center text-base text-reliableBlack font-bold uppercase border border-reliableBlack cursor-pointer"
          >
            Kembali ke beranda
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MaintainScreenSection;
